// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f874ede2","239":"d7e3a2cf","453":"d76ccc26","455":"8d3736cb"}[chunkId] + ".chunk.js";
};